import React from "react";
import { Layout, Row, Col, Card } from "antd";
import {
  ShoppingCartOutlined,
  UnorderedListOutlined,
  DollarOutlined,
  CreditCardOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const { Content } = Layout;

const BkDashboard = () => {
  const { currentUser } = useSelector((state) => state.user);
  console.log("Current User:", currentUser.roles);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("persist:root");
    window.location.href = "/login";
  };

  const cardStyle = {
    background: "#3C3C3B",
    borderRadius: 12,
    textAlign: "center",
    padding: 24,
    cursor: "pointer",
    transition: "all 0.3s ease",
    color: "#fff",
  };

  // 🔹 Cards for non-driver users
  const defaultCards = [
    {
      title: "Create Delivery",
      icon: <ShoppingCartOutlined style={{ fontSize: 28 }} />,
      path: "/shipment",
    },
    {
      title: "All Orders",
      icon: <UnorderedListOutlined style={{ fontSize: 28 }} />,
      path: "/portal",
    },
    {
      title: "Transactions",
      icon: <DollarOutlined style={{ fontSize: 28 }} />,
      path: "/transactions",
    },
    {
      title: "Payment",
      icon: <CreditCardOutlined style={{ fontSize: 28 }} />,
      path: "/checkout",
    },
    {
      title: "Logout",
      icon: <LogoutOutlined style={{ fontSize: 28 }} />,
      logout: true,
    },
  ];

  // 🔹 Cards only for Driver role
  const driverCards = [
    {
      title: "Upload Photos",
      icon: <UnorderedListOutlined style={{ fontSize: 28 }} />,
      path: "/portal",
    },
    {
      title: "Logout",
      icon: <LogoutOutlined style={{ fontSize: 28 }} />,
      logout: true,
    },
  ];

  // 🔹 Check role
  const isDriver = currentUser?.roles?.includes("Driver");
  const cards = isDriver ? driverCards : defaultCards;

  return (
    <Layout
      className="bk-dashboard"
      style={{ minHeight: "100vh", background: "#000" }}
    >
      <Content style={{ padding: "40px" }}>
        <Row gutter={[24, 24]} justify="center">
          {cards.map((card, index) => (
            <Col xs={24} sm={12} md={12} lg={12} key={index}>
              {card.logout ? (
                <Card
                  hoverable
                  style={cardStyle}
                  bodyStyle={{ padding: 20 }}
                  onClick={handleLogout}
                >
                  {card.icon}
                  <h3 style={{ color: "#fff", marginTop: 12 }}>{card.title}</h3>
                </Card>
              ) : (
                <Link to={card.path} style={{ textDecoration: "none" }}>
                  <Card hoverable style={cardStyle} bodyStyle={{ padding: 20 }}>
                    {card.icon}
                    <h3 style={{ color: "#fff", marginTop: 12 }}>{card.title}</h3>
                  </Card>
                </Link>
              )}
            </Col>
          ))}
        </Row>
      </Content>
    </Layout>
  );
};

export default BkDashboard;
